import { Garantia } from "./style";
import { HiClock } from "react-icons/hi"
import Assinatura from "../../../../assets/garantia-img.webp"
import backInvestiment from "../../../../assets/wallpaper-garantia.webp"

function GarantiaComponent() {
  return (
    <Garantia backInvestiment={backInvestiment}>
      <div id="pather-div">
        <div id="children-div-text">
          <div id="title-div">
            <span>Sucesso no resultado!</span>
            <h1>Minha garantia.</h1>
          </div>
          <p id="paragraph">
            Usar as 4 habilidades (fala, escuta, leitura e audição) de maneira que possa se comunicar em inglês com naturalidade <span id="span-orange">em até 160 horas</span>. A garantia se dá dentro dos dados e resultados obtidos nos últimos 13 anos. Esse resultado será obtido certamente ao se aplicar todo o diferencial, em sua totalidade.
          </p>
        </div>
        <div id="children-div-img">
            <figure>
                <img src={Assinatura} alt="text" />
            </figure>
            <h3><HiClock/> 8 meses ou 160 horas</h3>
        </div>
      </div>
    </Garantia>
  );
}

export default GarantiaComponent;
